// extracted by mini-css-extract-plugin
export default {"subBannerWrap":"SubBanner_subBannerWrap__7acXA","subText":"SubBanner_subText__lHMFe"};